<template>
  <el-row class="upload">
    <el-row class="upload-bd">
      <el-upload class="upload-label" action="#" :show-file-list="false" :disabled="image._disabled" :http-request="fnUploadRequest" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
        <!-- <img v-if="image.image_url" :src="image.image_url | th"> -->
        <img v-if="image.image_url" :src="image.image_url">
        <i v-else class="xy xy-icon8 iconphoto"></i>
        <span style="position: absolute;right:120px" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 1, 0.8)" v-loading="loading"></span>
      </el-upload>
    </el-row>
    <el-row class="upload-ft"><em v-show="image._required" class="is-required mainColor required">*</em>{{image._title}}</el-row>
  </el-row>
</template>

<script>
import { isSuccess } from "@/assets/js/utils"
export default {
  data () {
    return {
      loading: false
    }
  },
  props: {
    image: {
      _title: '',
      _required: false,
      _disabled: false,
      image_url: null,
    }
  },
  created () {
  },
  methods: {
    handleAvatarSuccess (response, file, fileList) {
      let that = this;
      let reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = function (e) {
        that.image.image_url = e.target.result;
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
      }
      return (isJPG || isPNG);
    },
    async fnUploadRequest (option) {
      this.$emit("onstart", 1);
      this.loading = true;
      _global_.uploadIng.push(1)
      this.api(100999, {}).then(res => {
        let data
        if (data = this.utils.isSuccess(res)) {
          let OSS = require('ali-oss');
          let store = new OSS({
            region: data.aliyun_region,
            accessKeyId: data.access_key_id,
            accessKeySecret: data.access_key_secret,
            stsToken: data.security_token,
            bucket: data.aliyun_bucket
          });
          let random_name = this.guid() + '.' + option.file.name.split('.').pop()
          store.put(random_name, option.file).then(res => {
            this.image.image_url = res.url.replace(/static-5j56-com.oss-cn-shanghai.aliyuncs.com/, "static.5j56.com")
            let json = {
              url: this.image.image_url
            }
            this.loading = false;
            _global_.uploadIng.splice(0, 1)
            this.$emit('getUrl', json)
          })
        }
      })
    },
    guid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
  }
}
</script>

<style scoped lang="scss">
.iconphoto {
  font-size: 26px;
  opacity: 0.6;
}
.required {
  margin-right: 5px;
  position: relative;
  top: 2px;
  color: #f56c6c;
}
.loading-text {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-photo.vue